/**
 * Query key factory. Every key starts with the tenant scope so switching tenants never shows another
 * tenant's cached data (tenant isolation applies to the client cache too).
 */
export const queryKeys = {
  tenants: () => ['global', 'tenants'] as const,
  metricsOverview: (tenantId: string | null, range: { from?: string; to?: string } = {}) =>
    ['tenant', tenantId ?? 'all', 'metrics', 'overview', range] as const,
  scoped: (tenantId: string | null, ...rest: readonly unknown[]) => ['tenant', tenantId ?? 'all', ...rest] as const,
};
